import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS styles

import './App.css';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import About from './Components/About';
import Services from './Components/Services';
import Testimonials from './Components/Testimonials';
import Gallery from './Components/Gallery';
import Contact from './Components/Contact';
import GoogleReviewCard from './Components/GoogleReviewCard';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false }); // you can customize this
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div data-aos="fade-up"><Hero /></div>
      <div data-aos="fade-right"><About /></div>
      <div data-aos="fade-left"><Services /></div>
      <div data-aos="zoom-in"><Testimonials /></div>
      <div data-aos="fade-up"><GoogleReviewCard /></div>
      <div data-aos="flip-left"><Gallery /></div>
      <div data-aos="fade-up"><Contact /></div>
      <div className="floating-buttons" data-aos="fade-left" data-aos-delay="500">
      <a
        href="https://wa.me/919082688403?text=Hi%2C%20I%27m%20interested%20in%20your%20photography%20and%20videography%20services.%20Could%20you%20please%20share%20more%20details%3F"
        className="floating-btn whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      <a
        href="mailto:rdoshi1997@gmail.com?subject=Photography%20Inquiry&body=Hi%2C%20I'm%20interested%20in%20your%20photography%20services.%20Please%20share%20more%20details."
        className="floating-btn email"
      >
        <i className="fas fa-envelope"></i>
      </a>
    </div>
    </div>
  );
}

export default App;